/* Strictly requires to pure javascript modules that need to be loaded with priority (e.g. for interactivity purposes */

// Sequence indifferent
require('../library/legacy/a11y.js');
require('../library/header.js');
